import { LitElement, html } from 'lit';
import { ContextConsumer } from '@lit/context';
import { authContext } from '../../services/context/auth-context.js';
import '../icons/user-icon.js';
import '../icons/user-anon-icon.js';

class AppHeader extends LitElement {
    static properties = {
        authState: { type: Object, state: true },
    };

    // No Shadow DOM - use Light DOM for Tailwind compatibility
    createRenderRoot() {
        return this;
    }

    constructor() {
        super();
        this.authState = null;
    }

    connectedCallback() {
        super.connectedCallback();
        // Subscribe to auth context using functional API
        this._authConsumer = new ContextConsumer(this, {
            context: authContext,
            subscribe: true,
            callback: (value) => {
                this.authState = value;
            },
        });
    }

    get isLoggedIn() {
        return this.authState?.authenticated ?? false;
    }

    get userEmail() {
        return this.authState?.user?.email ?? null;
    }

    get displayEmail() {
        if (!this.userEmail) return '';
        const maxLength = 25;
        return this.userEmail.length > maxLength
            ? `${this.userEmail.substring(0, maxLength)}...`
            : this.userEmail;
    }

    render() {
        return html`
            <header role="banner">
                <nav class="fixed h-11 top-0 w-full bg-dark-grey z-10">
                    <div
                        class="w-full px-4 md:w-11/12 md:mx-auto lg:w-2/3 lg:mx-auto xl:w-1/2 xl:mx-auto flex items-center h-full justify-between"
                    >
                        <div class="flex items-center text-white text-xl font-bold h-full">
                            <img
                                class="h-5 md:h-7 my-2"
                                src="/reach-white-on-clear.png"
                                alt="REACH Logo"
                                @error="${this._handleLogoError}"
                            />
                        </div>

                        <div class="flex items-center text-white h-full px-4">
                            ${this.isLoggedIn
                                ? html`<user-icon class="mr-2 text-peppermint"></user-icon
                                      ><span
                                          class="hidden md:block text-sm"
                                          title="${this.userEmail || ''}"
                                          >${this.displayEmail}</span
                                      >`
                                : html`<user-anon-icon class="text-gray-400"></user-anon-icon>`}
                        </div>
                    </div>
                </nav>
            </header>
        `;
    }

    _handleLogoError(e) {
        // Fallback to text if logo fails to load
        e.target.style.display = 'none';
        const textNode = document.createTextNode('REACH');
        e.target.parentNode.appendChild(textNode);
    }
}

customElements.define('app-header', AppHeader);
